import { render } from "./add-hors-service.vue?vue&type=template&id=44e6f142"
import script from "./add-hors-service.vue?vue&type=script&lang=js"
export * from "./add-hors-service.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__